import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import ClusterViewItemDetails from "./ClusterViewItemDetails"
import ClusterViewItemArticles from "./ClusterViewItemArticles"
import ClusterViewItemTopics from "./ClusterViewItemTopics"

const ClusterViewItem = ({ model, isFetching }) => (
    <ItemDetailsColumns className="item-container" id="cluster-item">
        <ItemDetailsColumn>
            <ClusterViewItemDetails
                title={model.title}
                time={model.time}
                description={model.description}
                image_url={model.image_url}
                isFetching={isFetching}
            />
            <ClusterViewItemTopics
                topics={model.topics}
                isFetching={isFetching}
            />
        </ItemDetailsColumn>
        <ItemDetailsColumn>
            <ClusterViewItemArticles
                articles={model.articles}
                isFetching={isFetching}
            />
            <ClusterViewItemTopics
                concepts={model.concepts}
                isFetching={isFetching}
            />
        </ItemDetailsColumn>
    </ItemDetailsColumns>
)

export default ClusterViewItem
